import { styled, Switch } from '@mui/material';

export const StyledMuiSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
      '& + .MuiSwitch-track': {
        opacity: 0.8,
      },
    },
    '&.Mui-checked': {
      color: theme.colors.blue,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.colors.blue,
        opacity: 0.5,
      },
      '&:hover': {
        backgroundColor: `${theme.colors.blue}20`, // 20 is hex for 12% opacity
        '& + .MuiSwitch-track': {
          opacity: 0.7,
        },
      },
    },
    '&:not(.Mui-checked)': {
      color: theme.colors.grey,
      '& + .MuiSwitch-track': {
        backgroundColor: theme.colors.grey,
        opacity: 0.3,
      },
      '&:hover': {
        backgroundColor: `${theme.colors.grey}20`,
        '& + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
    },
  },
}));
